const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

function tokenizeHtml(html) {
    const tokens = [];
    let start = 0;
    let index = 0;
    while (index < html.length) {
        if (html[index] !== '<') {
            index += 1;
            continue;
        }
        if (index > start) tokens.push(html.slice(start, index));
        const tagStart = index;
        let quote = null;
        index += 1;
        while (index < html.length) {
            const char = html[index];
            if (quote) {
                if (char === quote) quote = null;
            } else if (char === '"' || char === "'") {
                quote = char;
            } else if (char === '>') {
                index += 1;
                break;
            }
            index += 1;
        }
        tokens.push(html.slice(tagStart, index));
        start = index;
    }
    if (start < html.length) tokens.push(html.slice(start));
    return tokens;
}

export function linkProductsInHtml(html, products = []) {
    if (!html || !products.length) return html || '';
    const productByLabel = new Map();
    products.forEach(product => {
        const label = [product.name, product.variety].filter(Boolean).join(' ').trim();
        if (label && !productByLabel.has(label.toLocaleLowerCase())) {
            productByLabel.set(label.toLocaleLowerCase(), product);
        }
    });
    const labels = Array.from(productByLabel.keys()).sort((a, b) => b.length - a.length);
    if (!labels.length) return html;
    const matcher = new RegExp(`(^|[^\\p{L}\\p{N}])(${labels.map(escapeRegExp).join('|')})(?=$|[^\\p{L}\\p{N}])`, 'giu');
    let suppressedDepth = 0;

    return tokenizeHtml(html).map(token => {
        if (token.startsWith('<')) {
            if (/^<\/(a|script|style)\b/i.test(token)) suppressedDepth = Math.max(0, suppressedDepth - 1);
            else if (/^<(a|script|style)\b/i.test(token) && !/\/>$/.test(token)) suppressedDepth += 1;
            return token;
        }
        if (suppressedDepth) return token;
        return token.split(/(&(?:#\d+|#x[\da-f]+|[a-z][\w-]*);)/gi).map(part => {
            if (/^&(?:#\d+|#x[\da-f]+|[a-z][\w-]*);$/i.test(part)) return part;
            return part.replace(matcher, (match, prefix, reference) => {
                const product = productByLabel.get(reference.toLocaleLowerCase());
                return `${prefix}<a href="/products/${product.id}">${reference}</a>`;
            });
        }).join('');
    }).join('');
}
